import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrInputDate } from 'src/components/common/PbrInputDate/PbrInputDate';
import * as moment from 'moment';

interface IExpenseMaturityDate {
  customClass?: string
  value?: Date;
  onChange: (value: Date) => void;
}

export const ExpenseMaturityDate: React.FC<IExpenseMaturityDate & FormComponentProps> = ({
  customClass,
  value,
  onChange,
  form
}) => {
  return (
    <PbrInputDate
      className={customClass}
      name="expenseMaturityDate"
      formWrapper={form}
      formItemProps={{ label: "Data de Vencimento" }}
      placeholder="Data de Vencimento"
      value={value ? moment(value) : null}
      onChange={e => onChange(e?.toDate())}
      disabledDate={current => current < moment().add(3, "day") || current.isoWeekday() === 6 || current.isoWeekday() === 7}
      isRequired
      requiredMessage={"Data de Vencimento é obrigatória"}
    />
  );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseMaturityDate/ExpenseMaturityDate.tsx